import * as React from "react";

import DataTable from "react-data-table-component-with-filter";
import { Link } from "react-router-dom";

import Paper from "../../Components/Paper";
import Button from "../../Components/Button";
import FilterComponent from "../../Components/FilterComponent";
import { config } from "./Helper";
import { useLoader } from "../../Context/LoaderContext";
import axiosInstance from "../../Api/Axios";

import "./Contact.scss";

const customStyles = {
  headCells: {
    style: {
      color: "#fff",
      fontSize: "16px",
      fontWeight: "500",
      background: "#e75043",
      paddingBottom: "12px",
      paddingTop: "4px",
    },
  },
  cells: {
    style: {
      color: "#000",
      fontSize: "15px",
    },
  },
};

const Contact = () => {
  const [contact, setContact] = React.useState([]);
  const [filterText, setFilterText] = React.useState("");
  const [resetPaginationToggle, setResetPaginationToggle] =
    React.useState(false);

  const { setIsLoading } = useLoader();

  React.useEffect(() => {
    setIsLoading(true);
    axiosInstance
      .get(`${process.env.REACT_APP_API_URL}/leasing-contact-advisor`)
      .then((response) => {
        setIsLoading(false);
        setContact(response.data.data || []);
      })
      .catch(() => {
        setIsLoading(false);
      });
  }, [setIsLoading]);

  const filteredItems = contact.filter(
    (item) =>
      JSON.stringify(item).toLowerCase().indexOf(filterText.toLowerCase()) !==
      -1
  );
  const subHeaderComponent = React.useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };

    return (
      <FilterComponent
        onFilter={(e) => setFilterText(e.target.value)}
        onClear={handleClear}
        filterText={filterText}
      />
    );
  }, [filterText, resetPaginationToggle]);
  return (
    <Paper>
      <div className="wrap-tabs-offer">
        <h1>Être contacté</h1>
        <div className="box_link_funding">
          <Link to="/add-contact">
            <Button variant="dark">Déposez votre demande</Button>
          </Link>
        </div>
        <DataTable
          // title="Réclamation"
          columns={config()}
          data={filteredItems}
          customStyles={customStyles}
          pagination
          subHeader
          highlightOnHover
          subHeaderComponent={subHeaderComponent}
          noDataComponent={<div> Pas d'informations disponibles</div>}
          paginationComponentOptions={{
            rowsPerPageText: "Lignes par page:",
            rangeSeparatorText: "de",
            noRowsPerPage: false,
            selectAllRowsItem: false,
            selectAllRowsItemText: "tous",
          }}
        />
      </div>
    </Paper>
  );
};

export default Contact;
